import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "search-result-count" }
const _hoisted_2 = { class: "full-width" }

import { ref, computed, Ref } from 'vue';
import debounce from 'lodash.debounce';


export type GenericSearchOption = {[key: string]: unknown} | string;

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: /*#__PURE__*/_mergeModels({
    className: { default: '' },
    keyProp: {},
    search: {},
    resultDisplay: {},
    showResultsMenu: { type: Boolean, default: true },
    autoSearch: { type: Boolean, default: true },
    disable: { type: Boolean }
  }, {
    "text": { default: ''},
    "textModifiers": {},
    "results": { default: <GenericSearchOption[]>[]},
    "resultsModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(["item-selected", "search"], ["update:text", "update:results"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

const text = _useModel(__props, 'text');
const results = _useModel(__props, 'results');
const inputRef = ref(null);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = __props;

const emit = __emit;

const searchMenuOpen = ref(false);
const searchBarWidth = ref(0);

const searchCountText = computed(() => {
  if (typeof resultsCount.value === 'number' && displaySearchResults.value) {
    return `${resultsCount.value} result${resultsCount.value != 1 ? 's' : ''}`;
  }
  return '';
});

let displaySearchResults = ref<boolean>(props.autoSearch);

function updateDisplaySearchResults(display: boolean){
  displaySearchResults.value = props.autoSearch ? true : display;
}


function clear() {
  text.value = '';
  searchMenuOpen.value = false;
  updateDisplaySearchResults(false);

}

function validText(): boolean {
  return !!text.value && text.value.length >= 3;
}

const search = debounce(async () => {
  results.value = [];
  if (!validText() || !props.search) {
    return;
  }

  results.value = await props.search(text.value);

  updateDisplaySearchResults(true);

  const openSearchMenu = !!results.value.length && props.showResultsMenu;
  if (openSearchMenu) {
    // this is super hacky but could not find a good way to have the menu
    // match the search input box size since it may not be a fixed width
    const searchBarElement = document.getElementsByClassName(`${props.className}-search-input`)[0];
    searchBarWidth.value = searchBarElement?.clientWidth;

  }

  searchMenuOpen.value = openSearchMenu;

  emit('search', results.value);

}, 300);

const spanRefMap: Map<string, Ref> = new Map<string, Ref<Element>>();

function getOptionSpanRef(opt: GenericSearchOption): Ref {

  const key = getKey(opt);

  if (spanRefMap.has(key)) {
    return <Ref>spanRefMap.get(key);
  }

  const spanRef = ref(null);
  spanRefMap.set(key, spanRef);
  return spanRef;
}

function getKey(option: GenericSearchOption): string {

  if (typeof option === 'string') {
    return option;
  } else if (props.keyProp && option.hasOwnProperty(props.keyProp)) {
    return <string>option[props.keyProp];
  }

  return '';
}

function searchResultOverflowed(option: GenericSearchOption) {
  const element = getOptionSpanRef(option);

  if (element?.value?.[0]) {
    return element?.value?.[0]?.offsetWidth < element?.value?.[0]?.scrollWidth;
  }

  return false;
}

const resultsCount = computed(() => {
  return validText() ? results.value.length : '';
});

function resultDisplayText(result: GenericSearchOption): string {
  if (!props.resultDisplay) {
    return <string>result;
  }

  if (typeof props.resultDisplay === 'string' && typeof result === 'object') {
    return <string>result[props.resultDisplay];
  } else if (typeof props.resultDisplay === 'function') {
    return props.resultDisplay(result);
  } else {
    return <string>result;
  }
}

__expose({
  search
});


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_input, {
      dense: "",
      outlined: "",
      modelValue: text.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
        _cache[1] || (_cache[1] = ($event: any) => (_ctx.autoSearch && _unref(search)()))
      ],
      label: "Search for a term or code...",
      class: _normalizeClass(`${_ctx.className}-search-input`),
      for: "search-input",
      autocomplete: "off",
      onKeydown: _withKeys(_withModifiers(_unref(search), ["prevent"]), ["enter"]),
      ref_key: "inputRef",
      ref: inputRef,
      disable: _ctx.disable
    }, {
      append: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(searchCountText.value), 1),
        _withDirectives(_createVNode(_component_q_icon, {
          name: "fa-regular fa-xmark",
          class: "cursor-pointer",
          onClick: clear
        }, null, 512), [
          [_vShow, text.value !== '']
        ]),
        _createVNode(_component_q_separator, { vertical: "" }),
        _createVNode(_component_q_icon, {
          name: "fa-regular fa-magnifying-glass",
          class: "cursor-pointer",
          onClick: _unref(search)
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["modelValue", "class", "onKeydown", "disable"]),
    (_ctx.showResultsMenu)
      ? (_openBlock(), _createBlock(_component_q_menu, {
          key: 0,
          class: _normalizeClass(`io-mfe-ig-search-menu-portal`),
          modelValue: searchMenuOpen.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchMenuOpen).value = $event)),
          "no-parent-event": true,
          "no-focus": true,
          target: `.${_ctx.className}-search-input`,
          anchor: "bottom left",
          "max-width": searchBarWidth.value + 'px',
          "max-height": "200px",
          style: _normalizeStyle({'min-width': searchBarWidth.value + 'px'})
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_list, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (result) => {
                  return (_openBlock(), _createBlock(_component_q_item, {
                    key: getKey(result),
                    clickable: "",
                    onClick: ($event: any) => (emit('item-selected', result))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                ref_for: true,
                                ref: getOptionSpanRef(result),
                                class: "io-mfe-ig-search-bar-text-container"
                              }, [
                                _createElementVNode("span", _hoisted_2, _toDisplayString(resultDisplayText(result)), 1)
                              ], 512),
                              _createVNode(_component_q_icon, {
                                class: "io-mfe-ig-icon-button-small",
                                name: "fa-regular fa-circle-plus",
                                size: "16px"
                              }),
                              (searchResultOverflowed(result))
                                ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(resultDisplayText(result)), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "target", "max-width", "style"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})